<template>
<div>
  <el-card>
    <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
               icon="el-icon-plus" @click="handleAdd('新增用户')">新增</el-button>
    <el-table :data="tableData" border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              @select-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <!--<el-table-column prop="accountType" label="账户类型" />-->
      <el-table-column prop="backName" label="银行" />
      <el-table-column prop="backCardNum" label="银行卡" />
      <el-table-column prop="backCardName" label="户名" />
      <el-table-column prop="backOpenAdress" label="开户行" />
      <el-table-column prop="isDefault" label="默认" >
        <template slot-scope="scope">
          <span style="text-align: center">{{scope.row.isDefault?"是":"否"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit"
                     @click="handleEdit(scope.$index, scope.row,'修改字典项')">
            编辑
          </el-button>
          <el-button size="mini" type="success"
                     @click="handleDelete(scope.$index, scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="18">
          <el-form-item label="账号类型" prop="payBack">
            <el-select v-model="dialogForm.backName" clearable placeholder="请选择">
              <el-option
                  v-for="item in backOptions"
                  :key="item.id"
                  :label="item.backName"
                  :value="item.backName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="text" size="small" style="margin: 0 0 10px 20px"
                     icon="el-icon-plus" @click="addBackType('添加银行类型')">添加银行类型</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="账户" prop="backCardNum">
            <el-input v-model="dialogForm.backCardNum" placeholder="输入账户"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="开户名(姓名)" prop="backCardName">
            <el-input v-model="dialogForm.backCardName" placeholder="输入开户姓名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="收款码" prop="reciveMoneyCodeUrl">
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleAvatarSuccess"
                :on-remove="handleAvatarRemove">
              <img v-if="dialogForm.reciveMoneyCodeUrl" :src="dialogForm.reciveMoneyCodeUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="默认" prop="isDefault">
            <el-radio-group v-model="dialogForm.isDefault">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="操作密码" prop="operCode">
            <el-input v-model="dialogForm.operCode" placeholder="操作密码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogForm()" size="mini" type="primary">确认添加</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogBackTypeTitle" :visible.sync="dialogBackTypeFormVisible">
    <el-form ref="dialogBackTypeForm" :model="dialogBackTypeForm" label-width="220px">
      <el-form-item label="银行类型">
        <el-input v-model="dialogBackTypeForm.backTypeName" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="银行类别">
        <el-radio-group v-model="dialogBackTypeForm.isBackPay">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitBackType()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleBackTypeCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  getAllB2cBackInfos,
  getB2cBackCard,
  addB2cBackCard,
  updateB2cBackCard,
  deleteB2cBackCard,
  addB2cBackTypeInfos
} from "../../api/b2cbusiness/b2c_backcardmanage";
import {getJwtToken} from "../../lib/utils";
import {deleteSysDict} from "../../api/system/sys_dict";

export default {
name: "BanckCardManagelist",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryForm:{
      },
      backOptions:[],
      myheader: {
        JWTHeaderName: ""
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
        isDefault:0
      },
      dialogBackTypeFormVisible: false,
      dialogBackTypeTitle: "",
      dialogBackTypeRefName: "dialogBackTypeForm",
      dialogBackTypeForm: {
        isBackPay: false
      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
  this.myheader.JWTHeaderName = getJwtToken();
  getB2cBackCard({isPlateformAccount: true}, this.pagination).then(res=>{
    console.log(res.data)
    if (res.success){
      this.tableData = res.data.records;
      this.pagination.pageNum = res.data.current;
      this.pagination.pageSize = res.data.size;
      this.pagination.total = res.data.total;
    }
  });

    getAllB2cBackInfos().then(res=>{
      if (res.success){
        this.backOptions = res.data;
      }
    });
  },
  methods: {
    submitBackType(){
      addB2cBackTypeInfos(this.dialogBackTypeForm).then(res=>{
        if (res.success){
          this.dialogBackTypeFormVisible = false;
          getAllB2cBackInfos().then(res=>{
            if (res.success){
              this.backOptions = res.data;
            }
          });
        }
      });
    },
    handleBackTypeCloseDialog(){
      this.$refs[this.dialogBackTypeRefName].resetFields();
      this.dialogBackTypeFormVisible = false;
    },
    addBackType(title){
      this.dialogBackTypeTitle = title;
      this.dialogBackTypeFormVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  addData(){
    this.dialogForm.isPlateformAccount = true;
    addB2cBackCard(this.dialogForm).then(res=>{
      if (res.success){
        this.$message({message: res.data, type: 'success'});
        this.submitQueryForm();//新增之后，重新查询table
        this.handleCloseDialog();
      }
    });
  },
    updateData(){
      updateB2cBackCard(this.dialogForm)
          .then(res => {
            this.$message({message: res.data, type: 'success'});
            this.submitQueryForm();//修改之后，重新查询table
            this.handleCloseDialog();
          })
    },
    getData(){
      getB2cBackCard({isPlateformAccount: true}, this.pagination).then(res=>{
        console.log(res.data)
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    deleteData(row){
      this.$confirm("确定删除数据字典:["+row.backName+":"+row.backCardName+"]?")
          .then(_ => {
            deleteB2cBackCard(row.id)
                .then(res => {
                  this.submitQueryForm();//删除之后，重新查询table
                  this.$message({message: res.data, type: 'success'});
                }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            })
          });
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.dialogForm.reciveMoneyCodeUrl = res.data;
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}


.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}
</style>
